// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
export var joinUrl = function (base, path) {
    if (/^https?:\/\//i.test(path)) {
        return path;
    }
    return "".concat(base.replace(/\/+$/, ""), "/").concat(path.replace(/^\/+/, ""));
};
export var publicBucketUrl = function (publicBucketBaseUrl, path) {
    if (!path) {
        return undefined;
    }
    return joinUrl(publicBucketBaseUrl, path);
};
